import request from '@/utils/request'


// 获取服务受理
export function GetServiceAmounts(params){
  return request({
    url: 'feedback/service-amounts',
    method: 'get',
    params
  })
}

//获取每周通报

export function GetWeekReport(params){
  return request({
    url: 'feedback/weekly-report',
    method: 'get',
    params
  })
}
//获取月度汇报

export function GetMonthReport(params) {
  return request({
    url: 'feedback/monthly-report',
    method: 'get',
    params
  })
}
// 获取回收问卷数
export function GetQuestionNaireAmounts(params) {
  return request({
    url: 'feedback/questionnaire-amounts',
    method: 'get',
    params
  })
}



// WEBPACK FOOTER //
// ./src/api/DataPublic.js


// WEBPACK FOOTER //
// ./src/api/DataPublic.js